import { Image, Col, Row} from 'react-bootstrap';
import { useState, useEffect } from 'react';
import BasicSpinner from '../common/basic-spinner';

//================================================================

export default function ImageDetails({image}){

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!image) setLoading(true);
  },[image]);

  //----------------------------------------------------------------

  return(
    <>
      { image ?
        <>
          {/*<Row className="mb-2">
            <Col className="h4 text-truncate mb-2 text-center" xl>
              {image.name || "Untitled Image"}
            </Col>
          </Row>*/}
          <Row className="mb-4" sm={2}>
            <Col className="position-relative mb-2 p-0 text-center" xs={12}>
              <Col
                className="position-absolute h-100 w-100"
                hidden={!loading}
                style={{zIndex: 2}}
              >
                <BasicSpinner
                  className="position-absolute top-50 start-50 translate-middle"
                  text="Image loading..."
                />
              </Col>
              <Col
                className="position-absolute h-100 w-100 bg-light opacity-75"
                hidden={!loading}
                style={{zIndex: 1}}
              />
              <Col
                className='h-100 d-flex justify-content-center'
              >
                <Image
                  src={`/static/uploads/${image.owner_id}/${image.sha256}.${image.format.split('/')[1]}`}
                  onLoad={() => setLoading(false)}
                  onError={() => setLoading(false)}
                  style={{zIndex: 0}}
                  fluid
                />
              </Col>
            </Col>
            <Col xs={12}>

              {/*<Col className="text-truncate">
                <b>ID:</b> {image._id}
              </Col>*/}

              {/*<Col className="text-truncate">
                <b>Uploaded Filename:<b> {image.filename || "unset"}
              </Col>*/}

              {/*<Col className="text-truncate">
                <b>SHA256:</b> {image.sha256 || ""}
              </Col>*/}

              {/*<Col className="text-truncate">
                <b>Format:</b> {image.format || ""}
              </Col>*/}

              {/*<Col className="text-truncate">
                <b>Size (bytes):</b> {image.size || ""}
              </Col>*/}

              { image.description &&
                <Col>
                  <b> Description:</b> {image.description}
                </Col>
              }

              <Col className="text-truncate">
                <b>Type:</b> {image.image_type || ""}
              </Col>

              <Col>
                <b>Tags:</b> {image.tags.join(", ") || ""}
              </Col>

              <Col className="text-truncate">
                <b>{"Added On: "}</b>{image.created ? new Date(image.created * 1000).toLocaleString() : ""}
              </Col>

              { image.modified &&
                <Col className="text-truncate">
                  <b>{"Last Updated: "}</b>{new Date(image.modified * 1000).toLocaleString()}
                </Col>
              }

              <Col>
                {image.is_private ? "Private" : "Public"}
              </Col>
            </Col>
          </Row>
        </>
        :
        <Col className="text-center"  xs={12}>
          {"Unable to load Image"}
        </Col>
      }
    </>
  );
}
